(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-switcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-switcher')) {
    customElements.define(
      'collection-switcher',
      class extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelector('details');
          if (!this.details) return;
          this.close = () => {
            this.details.open = false;
            this.details.querySelector('summary')?.focus();
          };
          this.onDocumentClick = (event) => {
            if (!this.details.open) return;
            // Le voile du panneau desktop est un pseudo-élément du <details> :
            // un clic dessus a le <details> lui-même pour cible.
            if (!this.contains(event.target) || event.target === this.details) {
              this.details.open = false;
            }
          };
          this.onKeydown = (event) => {
            if (event.key === 'Escape' && this.details.open) this.close();
          };
          this.querySelector('[ref="close"]')?.addEventListener('click', this.close);
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeydown);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeydown);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  // L'encart occupait toute la hauteur de la ligne, titre et prix des fiches compris.
  // Le ratio des visuels étant réglé sur « adapt », on ne peut pas le caler en CSS :
  // on suit la hauteur réelle de la galerie d'une fiche voisine, au chargement comme
  // au redimensionnement. Sans JS, l'encart garde son ancien comportement.
  if (!customElements.get('collection-editorial-sizer')) {
    customElements.define('collection-editorial-sizer', class extends HTMLElement {
      connectedCallback() {
        this.item = this.closest('.collection-editorial-video');
        if (!this.item) return;

        const galleries = this.#findGalleries();
        if (!galleries.length) return;

        const syncHeight = () => {
          const height = this.#rowGallery(galleries).getBoundingClientRect().height;
          if (height <= 0) return;
          this.item.style.setProperty('--editorial-video-height', `${height}px`);
          this.item.setAttribute('data-media-synced', '');
        };

        this.observer = new ResizeObserver(syncHeight);
        galleries.forEach(gallery => this.observer.observe(gallery));
        syncHeight();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      // La fiche la plus proche de chaque côté : celle qui précède et celle qui suit.
      // En tête de grille (ou entre deux encarts) une seule des deux existe.
      #findGalleries() {
        const galleries = [];
        for (const direction of ['previousElementSibling', 'nextElementSibling']) {
          let sibling = this.item[direction];
          while (sibling) {
            const gallery = sibling.querySelector('.card-gallery');
            if (gallery) {
              galleries.push(gallery);
              break;
            }
            sibling = sibling[direction];
          }
        }
        return galleries;
      }

      // Le ratio des visuels étant réglé sur « adapt », deux lignes n'ont pas forcément
      // la même hauteur : seule une fiche de la ligne de l'encart fait référence. Le
      // choix se refait à chaque mesure, la grille se réorganisant au redimensionnement.
      #rowGallery(galleries) {
        const top = this.item.getBoundingClientRect().top;
        return galleries.find(gallery => Math.abs(gallery.getBoundingClientRect().top - top) <= 2) ?? galleries[0];
      }
    });
  }

  if (!customElements.get('collection-editorial-video')) {
    customElements.define('collection-editorial-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.muted = true;
        this.video.pause();
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.observer = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) this.video.play().catch(() => {});
          else this.video.pause();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
